define('plugin/category/CategoryPlugin',['require','lib/plugin/PluginAbstract','plugin/category/collection/CategoryCollection','plugin/category/step/CategoryStep','Config','lib/view/BookingUrlBuilder'],function (require) {
	
	var PluginAbstract = require('lib/plugin/PluginAbstract');
	var CategoryCollection = require('plugin/category/collection/CategoryCollection');
	var CategoryStep = require('plugin/category/step/CategoryStep');
	var Config = require('Config');
	var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

	return PluginAbstract.extend({

		_collection: null,
        _bookingModel: null,
		_serviceCollection: null,

		initialize: function () {
			this._collection = new CategoryCollection();
		},

		/**
		 * On step manager inits, add events
         */
		initStepManagerEvents: function () {
            this._collection.resetFilters();
            
            this._bookingModel = this._stepManager.getBookingModel();
			this.listenTo(this._stepManager, 'step:init:service', this.addServiceFilter);

			if (Config.getInstance().getPluginStatus('location')) {
				this.listenTo(this._stepManager, 'step:init:location', this.addLocationFilter);
			}
			this.listenTo(this._bookingModel, 'change:service_id', this.onServiceChanged);
			this.listenTo(this._collection, 'sync', this.onDataFetch);
		},

		/**
		 * Adds category step
		 *
		 * @param Array steps
		 * @return Array|null
		 */
		modifySteps: function (steps) {
			steps.unshift('category');
			return steps;
		},

		/**
		 * Returns plugin step object
		 *
		 * @see lib/controller/booking/BaseStep
		 * @param String step - step name
		 * @param Object params - step parameters
		 * @return BaseStep|null
		 */
		getStep: function (step, params) {
			if (step === 'category') {
				return new CategoryStep(_.extend({
					collection: this._collection
				}, params));
			}
		},

		/**
		 * Adds filter and comparator to services collection
		 *
		 * @param BaseStep step
		 * @param FilterableCollection collection
		 */
		addServiceFilter: function (step, collection) {
            this._serviceCollection = collection;

            this._serviceCollection.addFilter(_.bind(this.serviceFilter, this));
            this._serviceCollection.setComparator(_.bind(this.serviceComparator, this));
		},

		/**
		 * Adds filter to location collection
		 */
		addLocationFilter: function (step, collection) {
			collection.addFilter(_.bind(this.locationFilter, this));
		},

		/**
		 * Service comparator to sort services in category
		 *
		 * @param BaseModel model1
		 * @param BaseModel model2
		 * @return Number
		 */
		serviceComparator: function (model1, model2) {
			var category = this._collection.get(this._bookingModel.get('category_id'));

			return this._getModelPosition(model1, category) - this._getModelPosition(model2, category);
		},

        /**
		 * Return model position
		 *
         * @param model
         * @param categoryModel
         * @return {*}
         * @private
         */
		_getModelPosition: function (model, categoryModel) {
			var position = model.get('position');
			if (categoryModel) {
                position = _.indexOf(categoryModel.get('events'), model.get('id'));
            }
			if (model.get('class_id')) {
				position += this._serviceCollection.getClassOrderCorrection(
					BookingUrlBuilder.getInstance().getBookingMode()
				);
			}
			return position;
		},

		/**
		 * Filters service model
		 *
		 * @param Backbone.Model
		 * @return Boolean
		 */
		serviceFilter: function (model) {
			var category = this._collection.get(this._bookingModel.get('category_id'));
			if (!category) {
				return true;
			}
			if (_.indexOf(category.get('events'), model.get('id')) >= 0) {
				return true;
			}
			return false;
		},


		locationFilter: function (model) {
			if (!this._bookingModel.get('category_id')) {
				return true;
			}
			if(!model.get('categories')){
				return false;
			}

			var categories = model.get('categories') || [];
			categories = _.map(categories, function (val) { return parseInt(val)});

			return categories.indexOf(parseInt(this._bookingModel.get('category_id'))) >= 0;
		},

		onServiceChanged : function (model) {
			if(this.isTimelineWithoutLocation()){
				this.selectCategoryByService();
			}
		},

		onDataFetch : function(){
			if(this.isTimelineWithoutLocation()){
				this.selectCategoryByService();
			}
		},

		isTimelineWithoutLocation : function () {
			var timeline = Config.getInstance().getOption('timeline_type');
			var timelinesWithoutLocation = [Config.TIMELINE_GRID_WEEKLY];

			if (_.contains(timelinesWithoutLocation, timeline)) {
				return true;
			}
			return false;
		},

		selectCategoryByService : function () {
			var serviceId = this._bookingModel.get('service_id');

			if(serviceId) {
				var acceptedCategoryIds = this._collection.filter(function (locationModel) {
					var categoryServices = locationModel.get('events');
					if (_.contains(categoryServices, serviceId)) {
						return true;
					}
					return  false;
				}).map(function (model) {
					return model.id;
				});

				if(acceptedCategoryIds && acceptedCategoryIds.length === 1){ //if only one location
					this._bookingModel.set('category_id', acceptedCategoryIds[0]);
					this._bookingModel.set('category', this._collection.getModelObj(acceptedCategoryIds[0]));
				}
			}
		},
	});

});
